export default class SearchGuiaModel {
    constructor(data = {}) {
        this.estado = data.estado ? parseInt(data.estado) : 0;
        this.serie = data.serie ? parseInt(data.serie) : 0;
        this.titular = data.titular || '';
        this.titular_Destinatario = data.titular_Destinatario || '';
        this.viniedo = data.viniedo || '';
        this.destino = data.destino
            ? data.destino
                  .filter((d) => {
                      if (d) return parseInt(d);
                  })
                  .map((d) => parseInt(d))
            : [];
    }
}
